<!------------ START TEMPLATE ------------>
<template>
  <div>
    <!------------ START FORM ------------>
    <form role="form" @submit.stop.prevent="onSubmit">
      <!-----============================ OBS: No status deve ter um campo SELECT que irá trazer as opções criadas pelo Consultor na parte cadastro de Status do Menu Consultor  ==================------->

      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>Ativo</span>
          <vs-switch
            color="success"
            v-model="formCadastro.status"
            style="width: 60px"
          >
            <span slot="on">Ativo</span>
            <span slot="off">Inativo</span>
          </vs-switch>
        </div>
      </div>

      <div class="vx-row mb-4">
        <div class="vx-col sm:w-1/1 w-full">
          <span>Página</span>
          <vs-input
            class="w-full"
            name="Pagina"
            id="Pagina"
            v-model="formCadastro.pagina"
            v-validate="{ required: true }"
            :state="
              utilsList.validateState(this.veeFields, this.veeErrors, 'Pagina')
            "
            :danger="
              !utilsList.validateState(this.veeFields, this.veeErrors, 'Pagina')
            "
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
          />
        </div>
      </div>

      <div class="vx-row mb-4">
        <div class="vx-col sm:w-1/1 w-full">
          <span>Titulo</span>
          <vs-input
            class="w-full"
            name="Titulo"
            id="Titulo"
            v-model="formCadastro.titulo"
            v-validate="{ required: true }"
            :state="
              utilsList.validateState(this.veeFields, this.veeErrors, 'Titulo')
            "
            :danger="
              !utilsList.validateState(this.veeFields, this.veeErrors, 'Titulo')
            "
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
          />
        </div>
      </div>

      <div class="vx-row mb-4">
        <div class="vx-col sm:w-1/1 w-full">
          <span>Texto</span>
          <vs-textarea
            class="w-full"
            name="Texto"
            id="Texto"
            v-model="formCadastro.texto"
            v-validate="{ required: true }"
            :state="
              utilsList.validateState(this.veeFields, this.veeErrors, 'Texto')
            "
            :danger="
              !utilsList.validateState(this.veeFields, this.veeErrors, 'Texto')
            "
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            icon-no-border
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/1 w-full">
          <div>Imagem 1</div>
          <center v-if="formCadastro.imagem1">
            <img
              :src="formCadastro.imagem1"
              width="100%"
              style="max-width: 190px"
            />
          </center>
          <input
            id="fileUpload2"
            type="file"
            hidden
            v-on:change="selecionaImagem1"
          />
          <vs-button
            color="warning"
            type="border"
            class="mr-3 text-center"
            @click.stop.prevent="chooseFiles2()"
          >
            Escolher uma Imagem
            <feather-icon icon="UploadIcon" class="ml-2" />
            <Br />
            <vs-chip v-if="imagem1" class="mt-3">
              <vs-avatar icon-pack="feather" icon="icon-file" />
              <span>{{ imagem1 }}</span>
            </vs-chip>
          </vs-button>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/1 w-full">
          <div>Imagem 2</div>
          <center v-if="formCadastro.imagem2">
            <img
              :src="formCadastro.imagem2"
              width="100%"
              style="max-width: 190px"
            />
          </center>
          <input
            id="fileUpload3"
            type="file"
            hidden
            v-on:change="selecionaImagem2"
          />
          <vs-button
            color="warning"
            type="border"
            class="mr-3 text-center"
            @click.stop.prevent="chooseFiles3()"
          >
            Escolher uma Imagem
            <feather-icon icon="UploadIcon" class="ml-2" />
            <Br />
            <vs-chip v-if="imagem2" class="mt-3">
              <vs-avatar icon-pack="feather" icon="icon-file" />
              <span>{{ imagem2 }}</span>
            </vs-chip>
          </vs-button>
        </div>
      </div>

      <vs-alert
        v-if="$validator.errors.all().length > 0"
        color="danger"
        title="Atenção!!"
        active="true"
        class="my-3"
        style="height: auto !important"
      >
        <ul>
          <li
            class="mb-2"
            v-for="error in $validator.errors.all()"
            :key="error.id"
          >
            {{ error }}
          </li>
        </ul>
      </vs-alert>

      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button
            color="warning"
            type="border"
            class="mr-3 mb-2"
            @click.stop.prevent="onReset"
            >Cancelar</vs-button
          >
          <BotaoSubmit
            variant="success"
            :edit="this.dados.idTexto == null ? false : true"
            :aguarde="aguardeCadastro"
          ></BotaoSubmit>
        </div>
      </div>
    </form>
    <!------------ END FORM ------------>
  </div>
</template>
<!------------ END TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import locale from "../../../../locale";
import Datepicker from "vuejs-datepicker";
import * as lang from "vuejs-datepicker/src/locale";
import vSelect from "vue-select";
import service from "../../../../services";
import BotaoSubmit from "../../../../components/BotaoSubmit";
import utilsList from "../../../../utils/list";
import cpfCnpj from "../../../../services/cpfCnpj";
import dataFunctions from "../../../../utils/dateConversion";
import imageFunctions from "../../../../utils/imageFunctions";
export default {
  props: {
    sideBar: {
      type: Boolean,
    },
    dados: {
      type: Object,
    },
    contadorRender: {
      type: Number,
    },
  },
  watch: {
    dados(value) {
      this.preencheForm();
    },
    contadorRender(value) {
      this.preencheForm();
    },
  },
  data() {
    return {
      utilsList,
      decoded: utilsList.buscaToken(),
      aguardeCadastro: false,
      languages: lang,
      funcoesValicao: null,
      tiposPagamentos: [],
      files: new FormData(),
      imagem1: null,
      imagem2: null,
      formCadastro: {
        idTexto: null,
        status: true,
        titulo: null,
        texto: null,
        ordenacao: null,
        imagem1: null,
        imagem2: null,
        pagina: null,
      },
    };
  },
  methods: {
    chooseFiles2() {
      document.getElementById("fileUpload2").click();
      //this.$refs.fileUploadBtn.click();
      console.log(document.getElementById("fileUpload2"));
    },
    chooseFiles3() {
      document.getElementById("fileUpload3").click();
      //this.$refs.fileUploadBtn.click();
      console.log(document.getElementById("fileUpload3"));
    },
    selecionaImagem1(event) {
      console.log(event);
      var files = event.target.files || event.dataTransfer.files;
      if (!files.length) return;
      console.log(files[0]);
      this.files.set("file", event.target.files[0], event.target.files[0].name);
      this.imagem1 = event.target.files[0].name;

      this.$vs.loading();
      service
        .upload("Upload", "Texto", this.files)
        .then((response) => {
          this.formCadastro.imagem1 = response;
          console.log(response);
          this.$vs.loading.close();
          //this.onSubmit();
        })
        .catch((error) => {
          this.$vs.notify({
            position: "top-center",
            title: "Atenção",
            text: error,
            color: "danger",
          });
          this.$vs.loading.close();
        });
    },
    selecionaImagem2(event) {
      console.log(event);
      var files = event.target.files || event.dataTransfer.files;
      if (!files.length) return;
      console.log(files[0]);
      this.files.set("file", event.target.files[0], event.target.files[0].name);
      this.imagem2 = event.target.files[0].name;

      this.$vs.loading();
      service
        .upload("Upload", "Texto", this.files)
        .then((response) => {
          this.formCadastro.imagem2 = response;
          console.log(response);
          this.$vs.loading.close();
          //this.onSubmit();
        })
        .catch((error) => {
          this.$vs.notify({
            position: "top-center",
            title: "Atenção",
            text: error,
            color: "danger",
          });
          this.$vs.loading.close();
        });
    },
    preencheForm() {
      if (this.dados.idTexto) {
        this.formCadastro.idTexto = this.dados.idTexto;
        this.formCadastro.titulo = this.dados.titulo;
        this.formCadastro.texto = this.dados.texto;
        this.formCadastro.ordenacao = this.dados.ordenacao;
        this.formCadastro.imagem1 = this.dados.imagem1;
        this.formCadastro.imagem2 = this.dados.imagem2;
        this.formCadastro.pagina = this.dados.pagina;
        this.formCadastro.status = this.dados.deletedAt == null ? true : false;
      } else {
        this.resetForm();
      }
    },

    onSubmit() {
      var action = "Atualizar/" + this.formCadastro.idTexto;
      var metodo = "put";
      var msgRetorno = "Dados Atualizados com sucesso";
      if (!this.formCadastro.idTexto) {
        action = "Adicionar";
        metodo = "post";
        msgRetorno = "Texto Adicionado com sucesso";
      }

      var objSend = { ...this.formCadastro };

      this.$validator.validateAll().then((result) => {
        if (result) {
          this.aguardeCadastro = true;
          service[metodo]("Textos", action, objSend)
            .then((res) => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: "top-center",
                title: "Atenção",
                text: `Operação Realizada com sucesso`,
                color: "success",
              });
              this.$emit("concluido");
            })
            .catch((error) => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: "top-center",
                title: "Atenção",
                text: error,
                color: "danger",
              });
            });
        }
      });
    },

    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll("g", {}, `${model}/list`).then((res) => {
        res.data.forEach((element) => {
          if (element.deletedAt == null)
            this[array].push({
              id: element[campoPK],
              label: element[campoDescricao],
            });
        });
        console.log(this.regionais);
      });
    },
    resetForm() {
      this.formCadastro = {
        idTexto: null,
        status: true,
        titulo: null,
        texto: null,
        ordenacao: null,
      };
    },
    onReset(evt) {
      this.$emit("cancel");

      this.resetForm();
    },
  },
  mounted() {
    this.preencheForm();
  },
  created() {
    this.$validator.localize("ptBr", locale);
  },
  components: {
    Datepicker,
    BotaoSubmit,
    "v-select": vSelect,
  },
};
</script>
<!------------ END SCRIPT ------------>
<style scoped>
.vs-con-textarea {
  border: 1px solid rgba(0, 0, 0, 0.2) !important;
}
#fileInput {
  display: none;
}
.img label {
  width: 100%;
  font-weight: normal;
}

.img .containericone {
  text-align: center;
  border-radius: 10px;
  padding: 10px 20px;
  -webkit-box-shadow: 0px 0px 40px -20px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 0px 40px -20px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 0px 40px -20px rgba(0, 0, 0, 0.75);
  width: min-content;
  margin-top: 25px;
  margin-left: 43%;
  border: 1px solid #ccc;
}

.img .icone {
  font-size: 50px;
  color: #333;
}

.input-group-color {
  display: flex !important;
  gap: 5px;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
}

.color-picker {
  max-width: 2.5rem;
  height: 2.375rem;
  border: 1px solid rgba(60, 60, 60, 0.26);
  border-radius: 4px;
}
</style>
